import React from 'react';
import { useLocation } from 'react-router-dom';
import { BarChart3 } from 'lucide-react';
import ManagerTalentsStats from '../components/Statistics/ManagerTalentsStats';
import ManagerVideosStats from '../components/Statistics/ManagerVideosStats';
import ManagerYoutubeStats from '../components/Statistics/ManagerYoutubeStats';
import ManagerHiredStats from '../components/Statistics/ManagerHiredStats';
import ManagerStartedStats from '../components/Statistics/ManagerStartedStats';
import CustomReportsStats from '../components/Statistics/CustomReportsStats';
import PeriodComparisonStats from '../components/Statistics/PeriodComparisonStats';
import PeriodComparisonVideosStats from '../components/Statistics/PeriodComparisonVideosStats';
import PeriodComparisonYoutubeStats from '../components/Statistics/PeriodComparisonYoutubeStats';
import PeriodComparisonPortraitStats from '../components/Statistics/PeriodComparisonPortraitStats';
import PeriodComparisonHiredStats from '../components/Statistics/PeriodComparisonHiredStats';
import ManagerPortraitStats from '../components/Statistics/ManagerPortraitStats';
import PeriodComparisonStartedStats from '../components/Statistics/PeriodComparisonStartedStats';
import StatisticsDashboard from '../components/Statistics/StatisticsDashboard';
import OnboardingDashboard from '../components/Statistics/OnboardingDashboard';
import HrRecruitmentDashboard from '../components/Statistics/HrRecruitmentDashboard';

const ROUTE_COMPONENTS = {
  '/statistics/dashboard':                 StatisticsDashboard,
  '/statistics/managers-talents':          ManagerTalentsStats,
  '/statistics/managers-videos':           ManagerVideosStats,
  '/statistics/managers-youtube':          ManagerYoutubeStats,
  '/statistics/managers-hired':            ManagerHiredStats,
  '/statistics/managers-started':          ManagerStartedStats,
  '/statistics/custom-reports':            CustomReportsStats,
  '/statistics/period-comparison':         PeriodComparisonStats,
  '/statistics/period-comparison-videos':  PeriodComparisonVideosStats,
  '/statistics/period-comparison-youtube': PeriodComparisonYoutubeStats,
  '/statistics/managers-portrait':         ManagerPortraitStats,
  '/statistics/period-comparison-portrait': PeriodComparisonPortraitStats,
  '/statistics/period-comparison-hired':   PeriodComparisonHiredStats,
  '/statistics/period-comparison-started': PeriodComparisonStartedStats,
  '/statistics/onboarding':                OnboardingDashboard,
  '/statistics/hr-recruitment':            HrRecruitmentDashboard,
  '/statistics':                           StatisticsDashboard,
};

const ROUTE_TITLES = {
  '/statistics/dashboard':                  'Dashboard',
  '/statistics/managers-talents':           'Manager Talents',
  '/statistics/managers-videos':            'Manager Videos',
  '/statistics/managers-youtube':           'Manager YouTube',
  '/statistics/managers-hired':             'Manager Hired',
  '/statistics/managers-started':           'Manager Started',
  '/statistics/custom-reports':             'Custom Reports',
  '/statistics/period-comparison':          'Period Comparison',
  '/statistics/period-comparison-videos':   'Period Comparison Videos',
  '/statistics/period-comparison-youtube':  'Period Comparison YouTube',
  '/statistics/managers-portrait':          'Manager Portrait',
  '/statistics/period-comparison-portrait': 'Period Comparison Portrait',
  '/statistics/period-comparison-hired':    'Period Comparison Hired',
  '/statistics/period-comparison-started':  'Period Comparison Started',
  '/statistics/onboarding':                 'Onboarding',
  '/statistics/hr-recruitment':             'HR Recruitment',
};

const Statistics = () => {
  const { pathname } = useLocation();
  const ActiveComponent = ROUTE_COMPONENTS[pathname] || StatisticsDashboard;
  const subTitle = ROUTE_TITLES[pathname];

  return (
    <div className="min-w-0">
      <title>{subTitle ? `Statistics — ${subTitle} | Talent Service` : 'Statistics | Talent Service'}</title>
      <div className="mb-6 flex min-w-0 items-start gap-3">
        <BarChart3 className="mt-0.5 h-7 w-7 shrink-0 text-primary-600 sm:h-8 sm:w-8" />
        <div className="min-w-0">
          <h1 className="break-words text-2xl font-bold text-gray-900 dark:text-gray-100 sm:text-3xl">
            Statistics
          </h1>
          <p className="break-words text-sm text-gray-500 dark:text-gray-400 sm:text-base">
            Analytics and statistics on working with talents
          </p>
        </div>
      </div>

      <div className="min-w-0">
        <ActiveComponent />
      </div>
    </div>
  );
};

export default Statistics;
